import React, { forwardRef } from 'react';

import { cva } from 'class-variance-authority';

import { cn } from '../../lib/utils';

const variants = cva('flex flex-col items-start gap-4 rounded-xl border text-black shadow-glass backdrop-blur-lg', {
  variants: {
    variant: {
      popover:
        'border-[0.5px] border-white bg-gray-50/70 p-1 backdrop-saturate-[2.2] dark:border-white/3 dark:bg-neutral-700/70 dark:text-neutral-200',
      'agent-chat-dropdown':
        'max-h-80 w-74 overflow-y-auto rounded-2xl border-white/50 bg-white/80 dark:border-white/5 dark:bg-neutral-800/60',
      'conference-bubble-media-device-menu':
        'rounded-2xl border-white bg-gray-50/70 py-2 backdrop-blur-xl dark:border-white/5 dark:bg-neutral-800/50 dark:text-neutral-200',
    },
  },
  defaultVariants: {
    variant: 'popover',
  },
});

const GlassWrapper = forwardRef(({ children, className, variant, ...props }, ref) => {
  return (
    <div ref={ref} className={cn(variants({ variant }), className)} {...props}>
      {children}
    </div>
  );
});
GlassWrapper.displayName = 'GlassWrapper';

export { GlassWrapper, variants };
